import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ResultSliceType = {
  currentImageId: string
  isExternalModel: boolean
}

const INITIAL_STATE: ResultSliceType = {
  currentImageId: '',
  isExternalModel: false,
}

// Result 페이지에서 현재 보고 있는 이미지 ID를 관리하는 slice
export const resultSlice = createSlice({
  name: 'result',
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentImageId(state, action: PayloadAction<string>) {
      state.currentImageId = action.payload
    },
    resetCurrentImageId(state) {
      state.currentImageId = ''
    },
    setIsExternalModel(state, action: PayloadAction<boolean>) {
      state.isExternalModel = action.payload
    },
  },
})

export const { setCurrentImageId, resetCurrentImageId, setIsExternalModel } = resultSlice.actions

export default resultSlice.reducer
